import type { ChatMessageItem } from '@kanbu/chatbot-ui';
import {
  blocksOf,
  citationSourcesArtifactSchema,
  sourcesFromAnnotations,
  type AnswerAttribution,
  type CitationAnnotation,
} from '@kanbu/schema/contracts';

export function sourceEvidence(message: ChatMessageItem, isVoice: boolean) {
  const blocks = blocksOf(message);
  const textBlocks = blocks.filter(block => block.type === 'text');
  const attribution =
    textBlocks.find(block => block.attribution?.status === 'selected')
      ?.attribution ??
    textBlocks.findLast(block => block.attribution)?.attribution;
  const legacyVoice = isVoice && !attribution;
  const annotations: CitationAnnotation[] = [];
  for (const block of blocks) {
    if (block.type !== 'tool_result') continue;
    const artifact = block.artifact;
    const wrapped =
      artifact && typeof artifact === 'object' && 'citationSources' in artifact
        ? artifact.citationSources
        : artifact;
    const parsed = citationSourcesArtifactSchema.safeParse(wrapped);
    if (!parsed.success) continue;
    for (const [id, source] of Object.entries(parsed.data.sources)) {
      annotations.push({
        type: 'citation',
        id,
        url: source.url,
        title: source.fileName,
        source_type: source.type,
      });
    }
  }
  const existing = message.sources?.length
    ? message.sources
    : sourcesFromAnnotations(blocks);
  const retrieved =
    sourcesFromAnnotations([{ type: 'text', text: '', annotations }]) ?? [];

  return {
    status: (legacyVoice
      ? 'legacy'
      : (attribution?.status ??
        (existing?.length
          ? 'selected'
          : 'missing'))) as AnswerAttribution['status'],
    selected:
      legacyVoice || (attribution && attribution.status !== 'selected')
        ? []
        : existing,
    retrieved: retrieved.length
      ? retrieved
      : legacyVoice
        ? (existing ?? [])
        : [],
    hasAnswer: textBlocks.some(block => block.text.trim()),
  };
}
